import $, { AxiosRequestConfig, AxiosPromise } from 'axios';
import { RandomIP, Hash, IsNumber, GetURI } from './utilities';

const SUBSCRIBER_ID = 991902;
const IO_BASE_URL = 'https://mtls-ci-api.iovation.com';
const LK_BASE_URL = `${GetURI()}/api/launch`;
const BASEURL = `${GetURI()}/api`;

$.defaults.timeout = 300000;

export interface TransactionInsight {
    name: string;
    value: string;
}

export interface IovationRequestData {
    user: string;
    ti: TransactionInsight[] | null;
    type: string;
}

export class Iovation {
    public name: string;
    public blackBox: string;
    public data: IovationRequestData;

    constructor(args: any) {
        if (args.name) {
            this.name = args.name;
        } else {
            this.name = '';
        }
        if (args.blackbox) {
            this.blackBox = args.blackbox;
        } else {
            this.blackBox = '';
        }
        if (args.data) {
            this.data = args.data;
        } else {
            this.data = { user: '', ti: [], type: 'apply' };
        }
        return this;
    }
    public Send(): AxiosPromise {
        if (!this.name.startsWith('launch')) {
            return $({
                url: `${BASEURL}/io`,
                method: 'POST',
                data: this.getUrls(),
                timeout: 300000,
            });
        } else {
            return $(this.getUrls());
        }
    }
    private clearKeyData(unReg: boolean) {
        if (this.data.user === undefined || this.data.user === '') {
            this.data.user = 'carlos.sanchez@iovation.com';
        }
        if (!unReg) {
            return {
                subscriberId: SUBSCRIBER_ID,
                userAccountCode: Hash(this.data.user, 12),
                blackBox: this.blackBox,
                userIPAddress: RandomIP(),
            };
        } else {
            return {
                subscriberId: SUBSCRIBER_ID,
                userAccountCode: Hash(this.data.user, 12),
            };
        }
    }
    private fraudForceData() {
        if (this.data.ti) {
            return {
              accountCode: Hash(this.data.user, 12),
              blackbox: this.blackBox,
              statedIp: RandomIP(),
              type: this.data.type,
              transactionInsight: this.formatTi(),
            };
        } else {
            return {
                accountCode: Hash(this.data.user, 12),
                blackbox: this.blackBox,
                statedIp: RandomIP(),
                type: this.data.type,
            };
        }
    }
    private launchKeyData() {
        if (this.data) {
            let out = {};
            if ((this.data as any).policy) {
                out = Object.assign(out,
                {
                    policy: (this.data as any).policy,
                });
            }
            if ((this.data as any).context) {
                out = Object.assign(out,
                {
                    context: (this.data as any).context,
                });
            }
            out = Object.assign(out, { username: this.data.user });
            return out;
        } else {
            return {};
        }
    }

    private formatTi(): Record<string, unknown> | null {
        if (this.data.ti) {
            const out: Record<string, unknown> = {};
            this.data.ti.forEach((ele) => {
                if (ele.name) {
                    out[ele.name] = ele.value
                }
            });
            return out;
        } else {
            return null;
        }
    }

    private getUrls(): AxiosRequestConfig {
        switch (this.name) {
          case 'fraudforce':
            return {
                url: `${IO_BASE_URL}/fraud/v1/subs/${SUBSCRIBER_ID}/checks`,
                data: this.fraudForceData(),
                method: 'POST',
            };
          case 'clearkey_register':
            return {
                url: `${IO_BASE_URL}/reg/v1/register`,
                data: this.clearKeyData(false),
                method: 'POST',
            };
          case 'clearkey_unregister':
            return {
                url: `${IO_BASE_URL}/reg/v1/resetPairing`,
                data: this.clearKeyData(true),
                method: 'POST',
            };
          case 'clearkey_check':
            return {
                url: `${IO_BASE_URL}/reg/v1/registrationCheck`,
                data: this.clearKeyData(false),
                method: 'POST',
            };
          case 'launchkey_auth':
            return {
                url: `${LK_BASE_URL}/${this.data.user}`,
                data: this.launchKeyData(),
                method: 'POST',
                timeout: 300000,
            };
          case 'launchkey_check':
            return {
                url: `${LK_BASE_URL}/${this.data.user}`,
                method: 'PUT',
                timeout: 300000,
            };
          case 'launchkey_group':
            return { url: `${LK_BASE_URL}` };
          default:
            return {
                url: `${IO_BASE_URL}/fraud/v1/subs/${SUBSCRIBER_ID}/checks`,
                data: this.fraudForceData(),
                method: 'POST',
                timeout: 300000,
            };
        }
      }
}
